export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-primary-500">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
              下载91精品影视APP
            </h2>
            <p className="text-sm md:text-base text-white/80 leading-relaxed mb-6 max-w-lg">
              官方正版 · 安全可靠 · 海量资源 · 高清流畅。支持Android和iOS双平台，扫码或点击下方按钮即可下载安装，开启你的掌上观影之旅。
            </p>
            <ul className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              {['1080P/4K超清画质', '海量片库每日更新', '离线下载随时观看', '多端同步无缝切换'].map((f) => (
                <li key={f} className="flex items-center gap-1.5 text-sm text-white/90 whitespace-nowrap">
                  <i className="ri-checkbox-circle-fill text-white/70"></i> {f}
                </li>
              ))}
            </ul>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white hover:bg-white/95 text-primary-600 font-bold text-sm whitespace-nowrap transition-all cursor-pointer"
              >
                <i className="ri-android-line text-lg"></i>
                Android版下载
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/10 hover:bg-white/20 text-white font-bold text-sm whitespace-nowrap border border-white/30 transition-all cursor-pointer"
              >
                <i className="ri-apple-line text-lg"></i>
                iOS版下载
              </a>
            </div>
            <p className="mt-4 text-xs text-white/50">
              支持 Android 7.0+ / iOS 13+ · 安装包大小约 45MB · 官方正版认证
            </p>
          </div>

          <div className="flex-shrink-0">
            <div className="relative w-[240px] h-[240px] md:w-[280px] md:h-[280px] bg-white rounded-3xl flex items-center justify-center p-6">
              <div className="text-center">
                <div className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-3 rounded-2xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-smartphone-line text-primary-600 text-2xl md:text-3xl"></i>
                </div>
                <div className="text-sm md:text-base font-bold text-foreground-900 mb-1">91精品影视</div>
                <div className="text-xs text-foreground-400 mb-3">V5.2.1 · 官方最新版</div>
                <div className="inline-flex items-center gap-1 px-4 py-2 rounded-full bg-primary-500 text-white text-xs font-bold whitespace-nowrap">
                  <i className="ri-download-2-line"></i>
                  立即下载
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}